module.exports = __webpack_public_path__ + "static/media/Gallery.8087334d.svg";